/**
 * Route definitions for the billing section (Payments page,
 * payment method management, tax file uploads, and payment detail).
 * Mirrors the pattern in views/orders/routes.tsx.
 */
import { RouteObject } from "react-router-dom";
import { GraphQL } from "@rpi/openapi-api";
import { featureFlags } from "../../../featureFlags";
import { withHandle } from "../../../utils/route.util";
import { BillingView } from "./BillingView";
import { PaymentMethodEditView } from "./PaymentMethodEditView";
import { PaymentView } from "./PaymentView";
import { PaymentViewV2 } from "./PaymentViewV2";
import { TaxFileUploadView } from "./TaxFileUploadView";
import { SandboxGuard } from "../../../components/SandboxGuard";

export const billingRoutes: RouteObject[] = [
  {
    path: "billing",
    element: <BillingView />,
    ...withHandle("admin-billing"),
    children: [
      {
        path: "payment-methods",
        ...withHandle("admin-billing-payment-methods", {
          requiredRole: [GraphQL.DashboardUserRole.CustomerAdmin, GraphQL.DashboardUserRole.User],
        }),
        children: [
          {
            path: ":token/edit",
            element: <PaymentMethodEditView redirect="../../" />,
            ...withHandle("payment-method-edit"),
          },
        ],
      },
      {
        path: "file-upload",
        ...withHandle("admin-billing-file-upload", {
          requiredRole: [GraphQL.DashboardUserRole.CustomerAdmin],
        }),
        element: <TaxFileUploadView />,
      },
    ],
  },
  {
    path: "payments",
    element: <SandboxGuard redirectTo="/dashboard/admin/billing" />,
    ...withHandle("admin-payments"),
    children: [
      {
        path: ":id",
        element: featureFlags.newPaymentDetails ? <PaymentViewV2 /> : <PaymentView />,
        ...withHandle("admin-payment-detail"),
      },
    ],
  },
];
